export const ROOT_PATH = "/";
export const DATE_RANGE_COMPARISON_PATH = "/date-range-compariso";
export const ADS_AND_SMBS_PATH = "/ads-and-smbs";
export const WTD_MTD_QTD_PATH = "/wtd-met-qtd";
export const AD_TRACKER_ORIGAMI = "/ad-tracker-origami";
export const AD_TRACKER_LEGACY = "/ad-tracker-legacy";
export const ADS_PAST_SLA = "/ads-past-sla";
export const PIXEL_TREE = "/pixel-tree";
